// Angular
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// Libraries
import { takeUntil } from 'rxjs';

// Models
import { AppCleanup } from '../../../../shared/models';

// Enviroment
import { environment } from '../../../../../environments/environment';

// Services
import { AuthService } from '../..';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../../../shared/services';

// Enums
import { StatusType } from '../../../../shared/enums';

@Component({
	selector: 'email-confirmation',
	templateUrl: './email-confirmation.component.html',
	styleUrls: ['./email-confirmation.component.scss'],
})
export class EmailConfirmationComponent extends AppCleanup implements OnInit, OnDestroy {
	token: string;
	username: string;

	constructor(
		private route: ActivatedRoute,
		private authService: AuthService,
		private translateService: TranslateService,
		private coreService: CoreService
	) {
		super();
	}

	ngOnInit() {
		this.route.queryParams.pipe(takeUntil(this.destroy)).subscribe((params) => {
			this.token = params['token'];
			this.username = params['username'];
			localStorage.setItem(environment.authTokenKey, this.token);

			this.authService
				.confirmEmail()
				.pipe(takeUntil(this.destroy))
				.subscribe(() => {
					const message = this.translateService.instant('MODULE.JDR.NOT_EMAILED');
					this.coreService.toast({ message: message, type: StatusType.DANGER });
				});
		});
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}
}
